export async function fetchWithRetry(
  input: RequestInfo,
  init?: RequestInit,
  retries = 3,
  baseDelay = 300
): Promise<Response> {
  let attempt = 0

  while (true) {
    const response = await fetch(input, init)

    if (response.ok || [400, 401, 403, 404].includes(response.status)) {
      // Success or client error: do not retry
      return response
    }

    attempt++

    if (attempt > retries) {
      throw new Error(
        `Fetch failed after ${retries} retries, endpoint ${input}`
      )
    }

    const jitter = Math.random() * baseDelay
    const delay = baseDelay * 2 ** (attempt - 1) + jitter

    await new Promise((res) => setTimeout(res, delay))
  }
}
